<script setup lang="ts">
import type { ChampionshipRegistrationSelectTeamTask } from "@/model/championship/championship-registration-select-team-task"
import type { TasksProps } from "@/pages/Tasks/Tasks/tasks-props"
import { $currency, useApp, useHttpClient, useHttpGet } from "@/vf"
import { toRefs } from "vue"
import type { ChampionshipRegistrationPayInvoiceData } from "./championship-registration"

const props = defineProps<TasksProps<ChampionshipRegistrationSelectTeamTask>>()

const emit = defineEmits<{
    (e: "updated"): void
}>()

const { task } = toRefs(props)
const { data } = await useHttpGet<ChampionshipRegistrationPayInvoiceData>(
    `/championship/registration/${task.value.organizationId}/pay-invoice/${task.value.id}`,
)
const http = useHttpClient()
const { apiLink } = useApp()

async function resetRegistration() {
    await http.post(`/championship/registration/${data.value!.registrationId}/reset`)
    emit("updated")
}

async function deleteRegistration() {
    await http.post(`/championship/registration/${data.value!.registrationId}/dev-delete`)
    emit("updated")
}
</script>
<template>
    <div class="py-3 px-5">
        <table class="table">
            <thead>
                <tr>
                    <th>Order Confirmations</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="oc of data?.orderConfirmations" :key="oc.id">
                    <td>
                        <a
                            :href="apiLink(`/championship/registration/${data!.registrationId}/order-confirmation/${oc.id}`)"
                            target="_blank"
                        >
                            {{ oc.orderConfirmationNumber }}
                        </a>
                    </td>
                    <td class="text-right">
                        {{ $currency(oc.sumInCents) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="p-5">
        <button type="button" class="btn btn-primary" @click="resetRegistration()">DEV: Zurücksetzen</button>
        <button type="button" class="btn btn-primary" @click="deleteRegistration()">DEV: Löschen</button>
    </div>
</template>
